<ng-container
  *ngrxLet="{
    items: items$,
    currencyCode: currencyCode$,
    currencySymbol: currencySymbol$,
  } as vm"
>
  @if (field.label) {
    <fmnts-label class="form-field__label form-field__label--external">
      {{ field.label | translateInline }}
    </fmnts-label>
  }

  <div class="grid">
    <fmnts-radio-group
      [(ngModel)]="selectedOption"
      class="grid w-full"
      [class.fmnts-radio-group--invalid]="showError"
    >
      @for (item of vm.items; track item) {
        <fmnts-radio-card
          [value]="item.value"
          [class]="_radioCardClass"
          [attr.data-testid]="'amount-proposal-' + item.value"
        >
          <div class="form-field__donation-amount-currency">
            {{ vm.currencyCode }}
          </div>
          <div class="form-field__donation-amount-label">
            {{ item.label | translateInline }}
          </div>
        </fmnts-radio-card>
      }
    </fmnts-radio-group>

    <div class="grid w-full form-field__donation-amount-interval-fields">
      <label [class]="_inputFieldClass">
        <div
          class="form-field__label form-field__text-label"
          [class.form-field__label--error]="showError"
        >
          @if (this._labelMonthlyInput) {
            {{ this._labelMonthlyInput | translateInline }}
          } @else {
            {{ 'monthly' | translate }}
          }
        </div>

        <input
          fmnts-decimal-input
          [(ngModel)]="monthlyAmount"
          class="form-field__input form-field__text-input"
          [class.form-field__input--error]="showError"
          autocomplete="off"
          step="0.01"
          inputmode="decimal"
          (blur)="_onTouched()"
        />
      </label>
      <label [class]="_inputFieldClass">
        <div
          class="form-field__label form-field__text-label"
          [class.form-field__label--error]="showError"
        >
          @if (this._labelYearlyInput) {
            {{ this._labelYearlyInput | translateInline }}
          } @else {
            {{ 'yearly' | translate }}
          }
        </div>

        <input
          fmnts-decimal-input
          [(ngModel)]="yearlyAmount"
          class="form-field__input form-field__text-input"
          [class.form-field__input--error]="showError"
          autocomplete="off"
          step="0.01"
          inputmode="decimal"
          (blur)="_onTouched()"
        />
      </label>
    </div>
  </div>

  <div class="form-field__error-message">
    @if (showError && control.errors) {
      <fmnts-form-error>{{
        control.errors
          | declarativeErrorMessage
            : field
            : declaration
            : { currency: vm.currencySymbol }
      }}</fmnts-form-error>
    }
  </div>
</ng-container>
